export const dispatchUniflow = (uniflowActionObject, storeName, action) => {
  const myType = action.type.replace(`${storeName}/`, '');
  if (uniflowActionObject[myType]) {
    return uniflowActionObject[myType](action);
  }
};

export default dispatchUniflow;
